import { Button } from "@/shared/components/ui";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from "@/shared/components/ui/dropdown-menu";
import {
  ChartNoAxesCombined,
  Compass,
  Ellipsis,
  FilePlusCorner,
  GitCompareArrows,
  Link,
  Users,
  View,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ToastService } from "@/shared/services/toast-popup-services";

interface RowActionsProps {
  specificationId: string;
  companyId: string;
}

export default function RowActions({
  specificationId,
  companyId,
}: RowActionsProps) {
  const navigate = useNavigate();

  const handleNavigateToSpecification = () => {
    navigate(
      `/dashboard/specification/create?specificationId=${specificationId}`
    );
  };

  const handleNavigateToProductDiscovery = () => {
    navigate(
      `/dashboard/specification/product-discovery?specificationId=${specificationId}&companyId=${companyId}`
    );
  };

  const handleNavigateToProductCompare = () => {
    navigate(
      `/dashboard/specification/product-compare?specificationId=${specificationId}&companyId=${companyId}`
    );
  };

  const handleNavigateToReport = () => {
    navigate(
      `/dashboard/specification/report?specificationId=${specificationId}&companyId=${companyId}`
    );
  };

  const handleCopySpecificationLink = async () => {
    const link = `${window.location.origin}/dashboard/specification/create?specificationId=${specificationId}`;
    try {
      await navigator.clipboard.writeText(link);
      ToastService.success({
        title: "Bağlantı kopyalandı",
      });
    } catch (err) {
      console.error("Failed to copy link:", err);
      ToastService.error({
        title: "Kopyalama başarısız",
      });
    }
  };

  const handleViewResponses = () => {
    navigate(
      `/dashboard/specification/supplier-responses?specificationId=${specificationId}`
    );
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="flex items-center justify-center w-8 h-8 bg-white rounded cursor-pointer hover:bg-accent transition-colors"
        >
          <Ellipsis className="w-4 h-4 text-foreground" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-fit">
        <DropdownMenuItem
          className="cursor-pointer"
          onClick={handleNavigateToSpecification}
        >
          <FilePlusCorner width={16} height={16} color="#09090B" />

          <span className="font-500 text-[14px] mt-0.5">Şartname</span>
        </DropdownMenuItem>

        <DropdownMenuItem
          className="cursor-pointer"
          onClick={handleNavigateToProductDiscovery}
        >
          <Compass width={16} height={16} color="#09090B" />

          <span className="font-500 text-[14px] mt-0.5">Ürün keşif</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          className="cursor-pointer"
          onClick={handleNavigateToProductCompare}
        >
          <GitCompareArrows width={16} height={16} color="#09090B" />

          <span className="font-500 text-[14px] mt-0.5">
            Ürün karşılaştırma
          </span>
        </DropdownMenuItem>
        <DropdownMenuItem
          className="cursor-pointer"
          onClick={handleNavigateToReport}
        >
          <ChartNoAxesCombined width={16} height={16} color="#09090B" />
          <span className="font-500 text-[14px] mt-0.5">Rapor</span>
        </DropdownMenuItem>

        <DropdownMenuSeparator />
        <DropdownMenuItem
          className="cursor-pointer"
          onClick={handleCopySpecificationLink}
        >
          <Link width={16} height={16} color="#09090B" />

          <span className="font-500 text-[14px] mt-0.5">
            Bağlantıyı kopyala
          </span>
        </DropdownMenuItem>
        <DropdownMenuItem
          className="cursor-pointer"
          onClick={handleViewResponses}
        >
          <View width={16} height={16} color="#09090B" />

          <span className="font-500 text-[14px] mt-0.5">
            Cevapları görüntüle
          </span>
        </DropdownMenuItem>
        <DropdownMenuSeparator />

        <DropdownMenuItem className="cursor-pointer">
          <Users width={16} height={16} color="#09090B" />

          <span className="font-500 text-[14px] mt-0.5">Yanıt topla</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
